module.exports = __webpack_public_path__ + "img/img_sld2.ad95ebb4.png";